import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import RootLayout from '../components/layout/RootLayout';
import AlertsPage from '../components/alerts/AlertsPage';
import WatchlistPage from '../components/watchList/WatchlistPage';
import { EventFeed } from '../components/event/EventFeed';
import EventDetailPage from '../pages/EventDetailPage';
import { ScannerPage } from '../components/scannerPage';
import NotFoundPage from '../pages/NotFoundPage';
import SignalDetailPage from '../pages/SignalDetailPage';
export const router = createBrowserRouter([
  {
    path: '/', 
    element: <RootLayout />,
    children: [
      {
        path: '/',
        element: <ScannerPage />,
      },
      {
        path: '/scanner',
        element: <ScannerPage />,
      },
      { path: '/signal/:ticker', element: <SignalDetailPage/> },
      {
        path: '/alerts',
        element: <AlertsPage />,
      },
      {
        path: '/watchlist',
        element: <WatchlistPage />,
      },
      {
        path: '/events',
        element: <EventFeed />,
      },
      {
        path: '/events/:id',
        element: <EventDetailPage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      }
    ],
  }
]);
